import { useMemo } from 'react';

import { JwtDecoder } from './jwt.decoder';
import { useJWTTokens } from './use-jwt-tokens.hook';

export const useJWT = () => {
  const tokens = useJWTTokens();

  const jwtPayload = useMemo(() => {
    if (!tokens.accessToken) {
      return null;
    }

    try {
      const result = JwtDecoder.decodeAccessToken(tokens.accessToken);

      if (!result.success) {
        console.error('JWT payload validation failed:', result.error);

        return null;
      }

      return result.data;
    } catch (error) {
      console.error('Failed to decode JWT:', error);

      return null;
    }
  }, [tokens.accessToken]);

  return jwtPayload;
};
